export const categoryOptions = [
  { value: "Electronics & Gadgets", label: "Electronics & Gadgets" },
  { value: "Groceries", label: "Groceries" },
  { value: "Fashion & Accessories", label: "Fashion & Accessories" },
  { value: "Real Estate & Housing", label: "Real Estate & Housing" },
  { value: "Furniture", label: "Furniture" },
  { value: "Beauty, Spas & Wellness", label: "Beauty, Spas & Wellness" },
  { value: "Baby & Mother Care", label: "Baby & Mother Care" },
  { value: "Tourism & Travel", label: "Tourism & Travel" },
  { value: "Sports", label: "Sports" },
  { value: "Automotive", label: "Automotive" },
  { value: "Events and Entertainment", label: "Events and Entertainment" },
  { value: "Restaurants & Eateries", label: "Restaurants & Eateries" }
];
